export enum AppEnvironments {
  Development = "dev",
  PreProduction = "preprod",
  Production = "prod",
  ProductionUs = "prod-us",
  ProductionFedRAMP = "prod-fedramp",
}
